import type { IActionItemsStatusesWithColor } from '../model/actionItemsStatuses';

export const needResponseStatuses: Array<IActionItemsStatusesWithColor> = [
  {
    name: 'New',
    color: '#BFE2EC',
    key: '0',
  },
  {
    name: 'Needs Response',
    color: '#55BBD0',
    key: '10',
  },
];

export const pendingUpdatesStatuses: Array<IActionItemsStatusesWithColor> = [
  {
    name: 'Snoozed',
    color: '#B6BBC7',
    key: '3',
  },
  {
    name: 'Waiting',
    color: '#E4E4E4',
    key: '2',
  },
  {
    name: 'Verifying',
    color: '#F6F7FA',
    key: '6',
  },
  {
    name: 'Troubleshoot',
    color: '#FCFCFD',
    key: 'troubleshootingHold',
  },
];
